
// 1.

// import { useEffect, useState, useContext } from "react";
// import {
//   Modal,
//   Button,
//   Form,
//   Row,
//   Col,
//   InputGroup,
// } from "react-bootstrap";

// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../api/AxiosApi";

// const UserDetailUpdate = ({
//   show,
//   handleClose,
//   userData,
//   onUpdate,
// }) => {
//   const { PrimaryColor } =
//     useContext(AppThemeContext);

//   // LOCAL STORAGE
//   const LOGIN_ID =
//     sessionStorage.getItem("LoginID") || "";

//   // FORM STATE
//   const [formData, setFormData] = useState({
//     userId: "",
//     username: "",
//     password: "",
//     plant_capacity: "",
//     dc_capacity: "",
//     address: "",
//     city: "",
//     country: "INDIA",
//     currency: "₹",
//     lat: "",
//     long: "",
//     rate: "",
//     co2_rate: "",
//     total_modules: "",
//     module_capacity: "",
//     module_make: "",
//   });

//   // SET DATA
//   useEffect(() => {
//     if (userData) {
//       setFormData({
//         userId: userData.user_id || "",
//         username: userData.username || "",

//         // PASSWORD BLANK BY DEFAULT
//         password: "",

//         plant_capacity:
//           userData.plant_capacity || "",

//         dc_capacity:
//           userData.dc_capacity || "",

//         address: userData.address || "",

//         city: userData.city || "",

//         country:
//           userData.country || "INDIA",

//         currency:
//           userData.currency || "₹",

//         lat: userData.lat || "",

//         long: userData.long || "",

//         rate: userData.rate || "",

//         co2_rate:
//           userData.co2_rate || "",

//         total_modules:
//           userData.total_modules || "",

//         module_capacity:
//           userData.module_capacity || "",

//         module_make:
//           userData.module_make || "",
//       });
//     }
//   }, [userData]);

//   // INPUT CHANGE
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     // NUMBER FIELDS
//     const numericFields = [
//       "plant_capacity",
//       "dc_capacity",
//       "lat",
//       "long",
//       "rate",
//       "co2_rate",
//       "total_modules",
//       "module_capacity",
//     ];

//     // ALLOW ONLY NUMBER + DOT
//     if (numericFields.includes(name)) {
//       const numericValue =
//         value.replace(/[^0-9.]/g, "");

//       const validValue = numericValue
//         .split(".")
//         .slice(0, 2)
//         .join(".");

//       setFormData((prev) => ({
//         ...prev,
//         [name]: validValue,
//       }));

//       return;
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // SUBMIT
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // VALIDATION
//     if (
//       !formData.username ||
//       !formData.password ||
//       !formData.address ||
//       !formData.city ||
//       !formData.plant_capacity ||
//       !formData.dc_capacity ||
//       !formData.lat ||
//       !formData.long ||
//       !formData.rate ||
//       !formData.co2_rate ||
//       !formData.total_modules ||
//       !formData.module_capacity ||
//       !formData.module_make
//     ) {
//       alert("Please fill all fields");
//       return;
//     }

//     try {
//       // API URL
//       const url =
//         `${BaseUrl}CMN_10_Update/PLANT_DET?` +
//         `USER_NAME=${encodeURIComponent(
//           formData.username
//         )}` +
//         `&ADDRESS=${encodeURIComponent(
//           formData.address
//         )}` +
//         `&CITY=${encodeURIComponent(
//           formData.city
//         )}` +
//         `&COUNTRY=${encodeURIComponent(
//           formData.country
//         )}` +
//         `&PLANT_CAPACITY=${encodeURIComponent(
//           formData.plant_capacity
//         )}` +
//         `&DC_CAPACITY=${encodeURIComponent(
//           formData.dc_capacity
//         )}` +
//         `&LATITUDE=${encodeURIComponent(
//           formData.lat
//         )}` +
//         `&LONGITUDE=${encodeURIComponent(
//           formData.long
//         )}` +
//         `&RATE=${encodeURIComponent(
//           formData.rate
//         )}` +
//         `&CURRENCY=${encodeURIComponent(
//           formData.currency
//         )}` +
//         `&CO2=${encodeURIComponent(
//           formData.co2_rate
//         )}` +
//         `&TOTAL_NO_MODULE=${encodeURIComponent(
//           formData.total_modules
//         )}` +
//         `&EACH_MODULE_CAPACITY=${encodeURIComponent(
//           formData.module_capacity
//         )}` +
//         `&MODULE_MAKE=${encodeURIComponent(
//           formData.module_make
//         )}`;

//       // BODY DATA
//       const bodyData =
//         new URLSearchParams();

//       bodyData.append(
//         "LOGIN_ID",
//         LOGIN_ID
//       );

//       bodyData.append(
//         "PASS_KEY",
//         "XYZ"
//       );

//       bodyData.append(
//         "WEB_KEY",
//         "WEBXYZ321"
//       );

//       // USER ENTERED PASSWORD
//       bodyData.append(
//         "PASSWORD",
//         formData.password
//       );

//       console.log(
//         "REQUEST URL:",
//         url
//       );

//       console.log(
//         "BODY DATA:",
//         bodyData.toString()
//       );

//       // API CALL
//       const response = await fetch(url, {
//         method: "POST",

//         headers: {
//           "Content-Type":
//             "application/x-www-form-urlencoded",
//         },

//         body: bodyData.toString(),
//       });

//       const data = await response.json();

//       console.log(
//         "UPDATE RESPONSE:",
//         data
//       );

//       if (data.success === true) {
//         alert(

//           `User Updated Successfully (${data.data})`
//         );

//         if (onUpdate) {
//           onUpdate(data);
//         }

//         handleClose();
//       } else {
//         alert(
//           data.message ||
//           "Update Failed"
//         );
//       }
//     } catch (error) {
//       console.error(
//         "UPDATE ERROR:",
//         error
//       );

//       alert("Something went wrong");
//     }
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={handleClose}
//       centered
//       size="lg"
//     >
//       {/* HEADER */}
//       <Modal.Header
//         closeButton
//         style={{
//           background: PrimaryColor,
//           color: "#fff",
//         }}
//       >
//         <Modal.Title>
//           Update User Details
//         </Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <Form onSubmit={handleSubmit}>
//           <Row>
//             {/* USER ID */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   User ID
//                 </Form.Label>

//                 <Form.Control
//                   type="text"
//                   value={formData.userId}
//                   readOnly
//                 />
//               </Form.Group>
//             </Col>

//             {/* PASSWORD */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Password
//                 </Form.Label>

//                 <Form.Control
//                   type="password"
//                   name="password"
//                   value={formData.password}
//                   onChange={handleChange}
//                   placeholder="Enter Password"
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* USER NAME */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   User Name
//                 </Form.Label>

//                 <Form.Control
//                   type="text"
//                   name="username"
//                   value={formData.username}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* CITY */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   City
//                 </Form.Label>

//                 <Form.Control
//                   type="text"
//                   name="city"
//                   value={formData.city}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* COUNTRY */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Country
//                 </Form.Label>

//                 <Form.Control
//                   type="text"
//                   name="country"
//                   value={formData.country}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* AC CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Plant AC Capacity
//                 </Form.Label>

//                 <InputGroup>
//                   <Form.Control
//                     type="number"
//                     step="any"
//                     name="plant_capacity"
//                     value={
//                       formData.plant_capacity
//                     }
//                     onChange={handleChange}
//                     required
//                   />

//                   <InputGroup.Text>
//                     {userData?.AC_Unit ||
//                       "kW"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* DC CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Plant DC Capacity
//                 </Form.Label>

//                 <InputGroup>
//                   <Form.Control
//                     type="number"
//                     step="any"
//                     name="dc_capacity"
//                     value={
//                       formData.dc_capacity
//                     }
//                     onChange={handleChange}
//                     required
//                   />

//                   <InputGroup.Text>
//                     {userData?.DC_Unit ||
//                       "kWp"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* CURRENCY */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Currency
//                 </Form.Label>

//                 <Form.Control
//                   type="text"
//                   value="₹"
//                   readOnly
//                   style={{
//                     backgroundColor: "#fff",
//                   }}
//                 />
//               </Form.Group>
//             </Col>

//             {/* RATE */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Electricity Rate
//                 </Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="rate"
//                   value={formData.rate}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>


//             {/* CO2 */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   CO2 Reduction Rate
//                 </Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="co2_rate"
//                   value={formData.co2_rate}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>


//             {/* LATITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Latitude
//                 </Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="lat"
//                   value={formData.lat}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* LONGITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Longitude
//                 </Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="long"
//                   value={formData.long}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>




//             {/* TOTAL MODULES */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Total Modules
//                 </Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="total_modules"
//                   value={
//                     formData.total_modules
//                   }
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Each Module Capacity
//                 </Form.Label>

//                 <Form.Control
//                   type="number"
//                   step="any"
//                   name="module_capacity"
//                   value={
//                     formData.module_capacity
//                   }
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE MAKE */}
//             <Col md={6}>
//               <Form.Group className="mb-1">
//                 <Form.Label>
//                   Module Make
//                 </Form.Label>

//                 <Form.Control
//                   type="text"
//                   name="module_make"
//                   value={
//                     formData.module_make
//                   }
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* ADDRESS */}
//           <Form.Group className="mb-1">
//             <Form.Label>
//               Address
//             </Form.Label>

//             <Form.Control
//               as="textarea"
//               rows={3}
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//               required
//             />
//           </Form.Group>

//           {/* BUTTONS */}
//           <div className="text-end mt-2">
//             <Button
//               variant="secondary"
//               onClick={handleClose}
//               className="me-2"
//             >
//               Cancel
//             </Button>

//             <Button
//               type="submit"
//               style={{
//                 backgroundColor:
//                   PrimaryColor,
//                 border: "none",
//               }}
//             >
//               Update
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default UserDetailUpdate;

// 2.

// import { useEffect, useState, useContext } from "react";
// import {
//   Modal,
//   Button,
//   Form,
//   Row,
//   Col,
//   InputGroup,
// } from "react-bootstrap";

// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../api/AxiosApi";

// const UserDetailUpdate = ({
//   show,
//   handleClose,
//   userData,
//   onUpdate,
// }) => {
//   const { PrimaryColor } = useContext(AppThemeContext);

//   // LOCAL STORAGE
//   const LOGIN_ID = sessionStorage.getItem("LoginID") || "";

//   // FORM STATE
//   const [formData, setFormData] = useState({
//     userId: "",
//     username: "",
//     password: "",
//     plant_capacity: "",
//     dc_capacity: "",
//     address: "",
//     city: "",
//     country: "",
//     currency: "₹",
//     lat: "",
//     long: "",
//     rate: "",
//     co2_rate: "",
//     total_modules: "",
//     module_capacity: "",
//     module_make: "",
//     Daily_Mail: "",
//     Event_Mail: "",
//   });

//   // SET DATA ON PROP CHANGE
//   useEffect(() => {
//     if (userData) {
//       setFormData({
//         userId: userData.user_id || "",
//         username: userData.username || "",
//         password: "", // PASSWORD BLANK BY DEFAULT
//         plant_capacity: userData.plant_capacity || "",
//         dc_capacity: userData.dc_capacity || "",
//         address: userData.address || "",
//         city: userData.city || "",
//         country: userData.country || "",
//         currency: userData.currency || "₹",
//         lat: userData.lat || "",
//         long: userData.long || "",
//         rate: userData.rate || "",
//         co2_rate: userData.co2_rate || "",
//         total_modules: userData.total_modules || "",
//         module_capacity: userData.module_capacity || "",
//         module_make: userData.module_make || "",
//         Daily_Mail: userData.Daily_Mail || "",
//         Event_Mail: userData.Event_Mail || "",
//       });
//     }
//   }, [userData]);

//   // INPUT CHANGE HANDLER
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     // NUMBER FIELDS (ALLOW ONLY NUMBER + DOT)
//     const numericFields = [
//       "plant_capacity",
//       "dc_capacity",
//       "lat",
//       "long",
//       "rate",
//       "co2_rate",
//       "total_modules",
//       "module_capacity",
//     ];

//     if (numericFields.includes(name)) {
//       const numericValue = value.replace(/[^0-9.]/g, "");
//       const validValue = numericValue.split(".").slice(0, 2).join(".");

//       setFormData((prev) => ({
//         ...prev,
//         [name]: validValue,
//       }));
//       return;
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // SUBMIT HANDLER
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // VALIDATION
//     if (
//       !formData.username ||
//       !formData.password ||
//       !formData.address ||
//       !formData.city ||
//       !formData.plant_capacity ||
//       !formData.dc_capacity ||
//       !formData.lat ||
//       !formData.long ||
//       !formData.rate ||
//       !formData.co2_rate ||
//       !formData.total_modules ||
//       !formData.module_capacity ||
//       !formData.module_make ||
//       !formData.Daily_Mail ||
//       !formData.Event_Mail
//     ) {
//       alert("Please fill all fields");
//       return;
//     }

//     try {
//       // API URL (FIXED SYNTAX ERROR HERE)
//       const url =
//         `${BaseUrl}CMN_10_Update/PLANT_DET?` +
//         `USER_NAME=${encodeURIComponent(formData.username)}` +
//         `&ADDRESS=${encodeURIComponent(formData.address)}` +
//         `&CITY=${encodeURIComponent(formData.city)}` +
//         `&COUNTRY=${encodeURIComponent(formData.country)}` +
//         `&PLANT_CAPACITY=${encodeURIComponent(formData.plant_capacity)}` +
//         `&DC_CAPACITY=${encodeURIComponent(formData.dc_capacity)}` +
//         `&LATITUDE=${encodeURIComponent(formData.lat)}` +
//         `&LONGITUDE=${encodeURIComponent(formData.long)}` +
//         `&RATE=${encodeURIComponent(formData.rate)}` +
//         `&CURRENCY=${encodeURIComponent(formData.currency)}` +
//         `&CO2=${encodeURIComponent(formData.co2_rate)}` +
//         `&TOTAL_NO_MODULE=${encodeURIComponent(formData.total_modules)}` +
//         `&EACH_MODULE_CAPACITY=${encodeURIComponent(formData.module_capacity)}` +
//         `&MODULE_MAKE=${encodeURIComponent(formData.module_make)}` +
//         `&Daily_Mail=${encodeURIComponent(formData.Daily_Mail)}` +
//         `&Event_Mail=${encodeURIComponent(formData.Event_Mail)}`;

//       // BODY DATA
//       const bodyData = new URLSearchParams();
//       bodyData.append("LOGIN_ID", LOGIN_ID);
//       bodyData.append("PASS_KEY", "XYZ");
//       bodyData.append("WEB_KEY", "WEBXYZ321");
//       bodyData.append("PASSWORD", formData.password);

//       console.log("REQUEST URL:", url);
//       console.log("BODY DATA:", bodyData.toString());

//       // API CALL
//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: bodyData.toString(),
//       });

//       const data = await response.json();

//       console.log("UPDATE RESPONSE:", data);

//       if (data.success === true) {
//         alert(`User Updated Successfully (${data.data})`);
//         if (onUpdate) {
//           onUpdate(data);
//         }
//         handleClose();
//       } else {
//         alert(data.message || "Update Failed");
//       }
//     } catch (error) {
//       console.error("UPDATE ERROR:", error);
//       alert("Something went wrong");
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose} centered size="lg">
//       {/* HEADER */}
//       <Modal.Header
//         closeButton
//         style={{
//           background: PrimaryColor,
//           color: "#fff",
//         }}
//       >
//         <Modal.Title>Update User Details</Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <Form onSubmit={handleSubmit}>
//           <Row>
//             {/* USER ID */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>User ID</Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={formData.userId}
//                   readOnly
//                 />
//               </Form.Group>
//             </Col>

//             {/* PASSWORD */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Password</Form.Label>
//                 <Form.Control
//                   type="password"
//                   name="password"
//                   value={formData.password}
//                   onChange={handleChange}
//                   placeholder="Enter Password"
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* USER NAME */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>User Name</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="username"
//                   value={formData.username}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* CITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>City</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="city"
//                   value={formData.city}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* COUNTRY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Country</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="country"
//                   value={formData.country}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* AC CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Plant AC Capacity</Form.Label>
//                 <InputGroup>
//                   <Form.Control
//                     type="text"
//                     name="plant_capacity"
//                     value={formData.plant_capacity}
//                     onChange={handleChange}
//                     required
//                   />
//                   <InputGroup.Text>
//                     {userData?.AC_Unit || "kW"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* DC CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Plant DC Capacity</Form.Label>
//                 <InputGroup>
//                   <Form.Control
//                     type="text"
//                     name="dc_capacity"
//                     value={formData.dc_capacity}
//                     onChange={handleChange}
//                     required
//                   />
//                   <InputGroup.Text>
//                     {userData?.DC_Unit || "kWp"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* CURRENCY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Currency</Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={formData.currency}
//                   readOnly
//                   style={{ backgroundColor: "#e9ecef" }}
//                 />
//               </Form.Group>
//             </Col>

//             {/* RATE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Electricity Rate</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="rate"
//                   value={formData.rate}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* CO2 */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>CO2 Reduction Rate</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="co2_rate"
//                   value={formData.co2_rate}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* LATITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Latitude</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="lat"
//                   value={formData.lat}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* LONGITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Longitude</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="long"
//                   value={formData.long}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* TOTAL MODULES */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Total Modules</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="total_modules"
//                   value={formData.total_modules}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Each Module Capacity</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="module_capacity"
//                   value={formData.module_capacity}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* DGR MAIL ID (FIXED TYPE TO EMAIL/TEXT) */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>DGR Mail ID</Form.Label>
//                 <Form.Control
//                   type="email"
//                   name="Daily_Mail"
//                   value={formData.Daily_Mail}
//                   onChange={handleChange}
//                   placeholder="example@mail.com"
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* EVENT MAIL ID (FIXED TYPE TO EMAIL/TEXT) */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Event Mail ID</Form.Label>
//                 <Form.Control
//                   type="email"
//                   name="Event_Mail"
//                   value={formData.Event_Mail}
//                   onChange={handleChange}
//                   placeholder="example@mail.com"
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE MAKE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Module Make</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="module_make"
//                   value={formData.module_make}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* ADDRESS */}
//           <Form.Group className="mb-3 mt-2">
//             <Form.Label>Address</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={3}
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//               required
//             />
//           </Form.Group>

//           {/* BUTTONS */}
//           <div className="text-end mt-3">
//             <Button
//               variant="secondary"
//               onClick={handleClose}
//               className="me-2"
//             >
//               Cancel
//             </Button>

//             <Button
//               type="submit"
//               style={{
//                 backgroundColor: PrimaryColor,
//                 border: "none",
//               }}
//             >
//               Update
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default UserDetailUpdate;

// 3.


// import { useEffect, useState, useContext } from "react";
// import {
//   Modal,
//   Button,
//   Form,
//   Row,
//   Col,
//   InputGroup,
// } from "react-bootstrap";

// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import { BaseUrl } from "../../../../api/AxiosApi";

// const UserDetailUpdate = ({
//   show,
//   handleClose,
//   userData,
//   onUpdate,
// }) => {
//   const { PrimaryColor } = useContext(AppThemeContext);

//   // LOCAL STORAGE
//   const LOGIN_ID = sessionStorage.getItem("LoginID") || "";

//   // FORM STATE
//   const [formData, setFormData] = useState({
//     userId: "",
//     username: "",
//     password: "",
//     plant_capacity: "",
//     dc_capacity: "",
//     address: "",
//     city: "",
//     country: "",
//     currency: "₹",
//     lat: "",
//     long: "",
//     rate: "",
//     co2_rate: "",
//     total_modules: "",
//     module_capacity: "",
//     module_make: "",
//     Daily_Mail: "",
//     Event_Mail: "",
//   });

//   // SET DATA ON PROP CHANGE
//   useEffect(() => {
//     if (userData) {
//       setFormData({
//         userId: userData.user_id || "",
//         username: userData.username || "",
//         password: "", // PASSWORD BLANK BY DEFAULT
//         plant_capacity: userData.plant_capacity || "",
//         dc_capacity: userData.dc_capacity || "",
//         address: userData.address || "",
//         city: userData.city || "",
//         country: userData.country || "",
//         currency: userData.currency || "₹",
//         lat: userData.lat || "",
//         long: userData.long || "",
//         rate: userData.rate || "",
//         co2_rate: userData.co2_rate || "",
//         total_modules: userData.total_modules || "",
//         module_capacity: userData.module_capacity || "",
//         module_make: userData.module_make || "",
//         Daily_Mail: userData.Daily_Mail || "",
//         Event_Mail: userData.Event_Mail || "",
//       });
//     }
//   }, [userData]);

//   // INPUT CHANGE HANDLER
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     // NUMBER FIELDS (ALLOW ONLY NUMBER + DOT)
//     const numericFields = [
//       "plant_capacity",
//       "dc_capacity",
//       "lat",
//       "long",
//       "rate",
//       "co2_rate",
//       "total_modules",
//       "module_capacity",
//     ];

//     if (numericFields.includes(name)) {
//       const numericValue = value.replace(/[^0-9.]/g, "");
//       const validValue = numericValue.split(".").slice(0, 2).join(".");

//       setFormData((prev) => ({
//         ...prev,
//         [name]: validValue,
//       }));
//       return;
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // MULTIPLE EMAIL VALIDATOR FUNCTION
//   const validateMultipleEmails = (emailsString) => {
//     if (!emailsString) return false;
    
//     // Comma से स्प्लिट करके हर एक ईमेल की जांच करें
//     const emailArray = emailsString.split(",").map((email) => email.trim());
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//     return emailArray.every((email) => emailRegex.test(email));
//   };

//   // SUBMIT HANDLER
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // VALIDATION
//     if (
//       !formData.username ||
//       !formData.password ||
//       !formData.address ||
//       !formData.city ||
//       !formData.plant_capacity ||
//       !formData.dc_capacity ||
//       !formData.lat ||
//       !formData.long ||
//       !formData.rate ||
//       !formData.co2_rate ||
//       !formData.total_modules ||
//       !formData.module_capacity ||
//       !formData.module_make ||
//       !formData.Daily_Mail ||
//       !formData.Event_Mail
//     ) {
//       alert("Please fill all fields");
//       return;
//     }

//     // MULTIPLE EMAILS VALIDATION CHECK
//     if (!validateMultipleEmails(formData.Daily_Mail)) {
//       alert("Please enter valid DGR Mail ID(s) separated by comma (e.g., abc@gmail.com, xyz@gmail.com)");
//       return;
//     }

//     if (!validateMultipleEmails(formData.Event_Mail)) {
//       alert("Please enter valid Event Mail ID(s) separated by comma (e.g., abc@gmail.com, xyz@gmail.com)");
//       return;
//     }

//     try {
//       // API URL
//       const url =
//         `${BaseUrl}CMN_10_Update/PLANT_DET?` +
//         `USER_NAME=${encodeURIComponent(formData.username)}` +
//         `&ADDRESS=${encodeURIComponent(formData.address)}` +
//         `&CITY=${encodeURIComponent(formData.city)}` +
//         `&COUNTRY=${encodeURIComponent(formData.country)}` +
//         `&PLANT_CAPACITY=${encodeURIComponent(formData.plant_capacity)}` +
//         `&DC_CAPACITY=${encodeURIComponent(formData.dc_capacity)}` +
//         `&LATITUDE=${encodeURIComponent(formData.lat)}` +
//         `&LONGITUDE=${encodeURIComponent(formData.long)}` +
//         `&RATE=${encodeURIComponent(formData.rate)}` +
//         `&CURRENCY=${encodeURIComponent(formData.currency)}` +
//         `&CO2=${encodeURIComponent(formData.co2_rate)}` +
//         `&TOTAL_NO_MODULE=${encodeURIComponent(formData.total_modules)}` +
//         `&EACH_MODULE_CAPACITY=${encodeURIComponent(formData.module_capacity)}` +
//         `&MODULE_MAKE=${encodeURIComponent(formData.module_make)}` +
//         `&Daily_Mail=${encodeURIComponent(formData.Daily_Mail)}` +
//         `&Event_Mail=${encodeURIComponent(formData.Event_Mail)}`;

//       // BODY DATA
//       const bodyData = new URLSearchParams();
//       bodyData.append("LOGIN_ID", LOGIN_ID);
//       bodyData.append("PASS_KEY", "XYZ");
//       bodyData.append("WEB_KEY", "WEBXYZ321");
//       bodyData.append("PASSWORD", formData.password);

//       console.log("REQUEST URL:", url);
//       console.log("BODY DATA:", bodyData.toString());

//       // API CALL
//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//         },
//         body: bodyData.toString(),
//       });

//       const data = await response.json();

//       console.log("UPDATE RESPONSE:", data);

//       if (data.success === true) {
//         alert(`User Updated Successfully (${data.data})`);
//         if (onUpdate) {
//           onUpdate(data);
//         }
//         handleClose();
//       } else {
//         alert(data.message || "Update Failed");
//       }
//     } catch (error) {
//       console.error("UPDATE ERROR:", error);
//       alert("Something went wrong");
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose} centered size="lg">
//       {/* HEADER */}
//       <Modal.Header
//         closeButton
//         style={{
//           background: PrimaryColor,
//           color: "#fff",
//         }}
//       >
//         <Modal.Title>Update User Details</Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <Form onSubmit={handleSubmit}>
//           <Row>
//             {/* USER ID */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>User ID</Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={formData.userId}
//                   readOnly
//                 />
//               </Form.Group>
//             </Col>

//             {/* PASSWORD */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Password</Form.Label>
//                 <Form.Control
//                   type="password"
//                   name="password"
//                   value={formData.password}
//                   onChange={handleChange}
//                   placeholder="Enter Password"
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* USER NAME */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>User/Plant Name</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="username"
//                   value={formData.username}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* CITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>City</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="city"
//                   value={formData.city}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* COUNTRY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Country</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="country"
//                   value={formData.country}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* AC CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Plant AC Capacity</Form.Label>
//                 <InputGroup>
//                   <Form.Control
//                     type="text"
//                     name="plant_capacity"
//                     value={formData.plant_capacity}
//                     onChange={handleChange}
//                     required
//                   />
//                   <InputGroup.Text>
//                     {userData?.AC_Unit || "kW"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* DC CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Plant DC Capacity</Form.Label>
//                 <InputGroup>
//                   <Form.Control
//                     type="text"
//                     name="dc_capacity"
//                     value={formData.dc_capacity}
//                     onChange={handleChange}
//                     required
//                   />
//                   <InputGroup.Text>
//                     {userData?.DC_Unit || "kWp"}
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Form.Group>
//             </Col>

//             {/* CURRENCY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Currency</Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={formData.currency}
//                   readOnly
//                   style={{ backgroundColor: "#e9ecef" }}
//                 />
//               </Form.Group>
//             </Col>

//             {/* RATE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Electricity Rate</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="rate"
//                   value={formData.rate}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* CO2 */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>CO2 Reduction Rate</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="co2_rate"
//                   value={formData.co2_rate}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* LATITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Latitude</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="lat"
//                   value={formData.lat}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* LONGITUDE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Longitude</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="long"
//                   value={formData.long}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* TOTAL MODULES */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Total Modules</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="total_modules"
//                   value={formData.total_modules}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE CAPACITY */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Each Module Capacity</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="module_capacity"
//                   value={formData.module_capacity}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* MODULE MAKE */}
//             <Col md={6}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Module Make</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="module_make"
//                   value={formData.module_make}
//                   onChange={handleChange}
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* DGR MAIL ID (ALLOWS MULTIPLE EMAILS WITH COMMA) */}
//             <Col md={12}>
//               <Form.Group className="mb-2">
//                 <Form.Label>DGR Mail ID</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="Daily_Mail"
//                   value={formData.Daily_Mail}
//                   onChange={handleChange}
//                   placeholder=""
//                   required
//                 />
//               </Form.Group>
//             </Col>

//             {/* EVENT MAIL ID (ALLOWS MULTIPLE EMAILS WITH COMMA) */}
//             <Col md={12}>
//               <Form.Group className="mb-2">
//                 <Form.Label>Event Mail ID</Form.Label>
//                 <Form.Control
//                   type="text"
//                   name="Event_Mail"
//                   value={formData.Event_Mail}
//                   onChange={handleChange}
//                   placeholder=""
//                   required
//                 />
//               </Form.Group>
//             </Col>

            
//           </Row>

//           {/* ADDRESS */}
//           <Form.Group className="mb-3 mt-2">
//             <Form.Label>Address</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={3}
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//               required
//             />
//           </Form.Group>

//           {/* BUTTONS */}
//           <div className="text-end mt-3">
//             <Button
//               variant="secondary"
//               onClick={handleClose}
//               className="me-2"
//             >
//               Cancel
//             </Button>

//             <Button
//               type="submit"
//               style={{
//                 backgroundColor: PrimaryColor,
//                 border: "none",
//               }}
//             >
//               Update
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default UserDetailUpdate;

// 4.

import { useEffect, useState, useContext } from "react";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  InputGroup,
} from "react-bootstrap";

import { AppThemeContext } from "../../../../context/AppThemeContext";
import { BaseUrl } from "../../../../api/AxiosApi";

const UserDetailUpdate = ({
  show,
  handleClose,
  userData,
  onUpdate,
}) => {
  const { PrimaryColor } = useContext(AppThemeContext);

  // LOCAL STORAGE
  const LOGIN_ID = sessionStorage.getItem("LoginID") || "";

  // FORM STATE
  const [formData, setFormData] = useState({
    userId: "",
    username: "",
    password: "",
    plant_capacity: "",
    dc_capacity: "",
    address: "",
    city: "",
    country: "",
    currency: "₹",
    lat: "",
    long: "",
    rate: "",
    co2_rate: "",
    total_modules: "",
    module_capacity: "",
    module_make: "",
    Daily_Mail: "",
    Event_Mail: "",
    Module_Area: "", // Camel/Pascal Case consistency
  });

  // SET DATA ON PROP CHANGE
  useEffect(() => {
    if (userData) {
      setFormData({
        userId: userData.user_id || "",
        username: userData.username || "",
        password: "", // PASSWORD BLANK BY DEFAULT
        plant_capacity: userData.plant_capacity || "",
        dc_capacity: userData.dc_capacity || "",
        address: userData.address || "",
        city: userData.city || "",
        country: userData.country || "",
        currency: userData.currency || "₹",
        lat: userData.lat || "",
        long: userData.long || "",
        rate: userData.rate || "",
        co2_rate: userData.co2_rate || "",
        total_modules: userData.total_modules || "",
        module_capacity: userData.module_capacity || "",
        module_make: userData.module_make || "",
        Daily_Mail: userData.Daily_Mail || "",
        Event_Mail: userData.Event_Mail || "",
        Module_Area: userData.Module_Area || "",
      });
    }
  }, [userData]);

  // INPUT CHANGE HANDLER
  const handleChange = (e) => {
    const { name, value } = e.target;

    // NUMBER FIELDS (ALLOW ONLY NUMBER + DOT)
    const numericFields = [
      "plant_capacity",
      "dc_capacity",
      "lat",
      "long",
      "rate",
      "co2_rate",
      "total_modules",
      "module_capacity",
      "Module_Area", // Added Module_Area for numeric restriction
    ];

    if (numericFields.includes(name)) {
      const numericValue = value.replace(/[^0-9.]/g, "");
      const validValue = numericValue.split(".").slice(0, 2).join(".");

      setFormData((prev) => ({
        ...prev,
        [name]: validValue,
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // FLEXIBLE EMAIL VALIDATOR (Allows Blank, Hyphen "-", or Semicolon ";" Separated Emails)
  const validateMultipleEmails = (emailsString) => {
    const trimmed = emailsString ? emailsString.trim() : "";

    if (!trimmed || trimmed === "-") {
      return true;
    }

    const emailArray = trimmed.split(";").map((email) => email.trim());
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emailArray.every((email) => email === "-" || email === "" || emailRegex.test(email));
  };

  // SUBMIT HANDLER
  const handleSubmit = async (e) => {
    e.preventDefault();

    // MANDATORY FIELDS VALIDATION (Added Module_Area)
    if (
      !formData.username ||
      !formData.password ||
      !formData.address ||
      !formData.city ||
      !formData.plant_capacity ||
      !formData.dc_capacity ||
      !formData.lat ||
      !formData.long ||
      !formData.rate ||
      !formData.co2_rate ||
      !formData.total_modules ||
      !formData.module_capacity ||
      !formData.module_make ||
      !formData.Module_Area
    ) {
      alert("Please fill all required fields");
      return;
    }

    // EMAIL VALIDATION CHECK
    if (!validateMultipleEmails(formData.Daily_Mail)) {
      alert("Please enter valid DGR Mail ID(s) separated by semicolon (;), '-' or leave it blank.");
      return;
    }

    if (!validateMultipleEmails(formData.Event_Mail)) {
      alert("Please enter valid Event Mail ID(s) separated by semicolon (;), '-' or leave it blank.");
      return;
    }

    try {
      // API URL (Fixed Syntax Error by removing extra semicolon before +)
      const url =
        `${BaseUrl}CMN_10_Update/PLANT_DET?` +
        `USER_NAME=${encodeURIComponent(formData.username)}` +
        `&ADDRESS=${encodeURIComponent(formData.address)}` +
        `&CITY=${encodeURIComponent(formData.city)}` +
        `&COUNTRY=${encodeURIComponent(formData.country)}` +
        `&PLANT_CAPACITY=${encodeURIComponent(formData.plant_capacity)}` +
        `&DC_CAPACITY=${encodeURIComponent(formData.dc_capacity)}` +
        `&LATITUDE=${encodeURIComponent(formData.lat)}` +
        `&LONGITUDE=${encodeURIComponent(formData.long)}` +
        `&RATE=${encodeURIComponent(formData.rate)}` +
        `&CURRENCY=${encodeURIComponent(formData.currency)}` +
        `&CO2=${encodeURIComponent(formData.co2_rate)}` +
        `&TOTAL_NO_MODULE=${encodeURIComponent(formData.total_modules)}` +
        `&EACH_MODULE_CAPACITY=${encodeURIComponent(formData.module_capacity)}` +
        `&MODULE_MAKE=${encodeURIComponent(formData.module_make)}` +
        `&Daily_Mail=${encodeURIComponent(formData.Daily_Mail)}` +
        `&Event_Mail=${encodeURIComponent(formData.Event_Mail)}` +
        `&MODULE_AREA=${encodeURIComponent(formData.Module_Area)}`;

      // BODY DATA
      const bodyData = new URLSearchParams();
      bodyData.append("LOGIN_ID", LOGIN_ID);
      bodyData.append("PASS_KEY", "XYZ");
      bodyData.append("WEB_KEY", "WEBXYZ321");
      bodyData.append("PASSWORD", formData.password);

      // API CALL
      const response = await fetch(url, { 
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: bodyData.toString(),
      });

      const data = await response.json();

      console.log("UPDATE RESPONSE:", data);

      if (data.success === true) {
        alert(`User Updated Successfully (${data.data})`);
        if (onUpdate) {
          onUpdate(data);
        }
        handleClose();
      } else {
        alert(data.message || "Update Failed");
      }
    } catch (error) {
      console.error("UPDATE ERROR:", error);
      alert("Something went wrong");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      {/* HEADER */}
      <Modal.Header
        closeButton
        style={{
          background: PrimaryColor,
          color: "#fff",
        }}
      >
        <Modal.Title>Update User Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            {/* USER ID */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>User ID</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.userId}
                  readOnly
                />
              </Form.Group>
            </Col>

            {/* PASSWORD */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter Password"
                  required
                />
              </Form.Group>
            </Col>

            {/* USER NAME */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>User/Plant Name</Form.Label>
                <Form.Control
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                /> 
              </Form.Group>
            </Col>

            {/* CITY */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* COUNTRY */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Country</Form.Label>
                <Form.Control
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* AC CAPACITY */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Plant AC Capacity</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    name="plant_capacity"
                    value={formData.plant_capacity}
                    onChange={handleChange}
                    required
                  />
                  <InputGroup.Text>
                    {userData?.AC_Unit || "kW"}
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>

            {/* DC CAPACITY */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Plant DC Capacity</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    name="dc_capacity"
                    value={formData.dc_capacity}
                    onChange={handleChange}
                    required
                  />
                  <InputGroup.Text>
                    {userData?.DC_Unit || "kWp"}
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>

            {/* CURRENCY */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Currency</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.currency}
                  readOnly
                  style={{ backgroundColor: "#e9ecef" }}
                />
              </Form.Group>
            </Col>

            {/* RATE */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Electricity Rate</Form.Label>
                <Form.Control
                  type="text"
                  name="rate"
                  value={formData.rate}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* CO2 */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>CO2 Reduction Rate</Form.Label>
                <Form.Control
                  type="text"
                  name="co2_rate"
                  value={formData.co2_rate}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* LATITUDE */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Latitude</Form.Label>
                <Form.Control
                  type="text"
                  name="lat"
                  value={formData.lat}
                  onChange={handleChange}
                  required 
                />
              </Form.Group>
            </Col>

            {/* LONGITUDE */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Longitude</Form.Label>
                <Form.Control
                  type="text"
                  name="long"
                  value={formData.long}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* TOTAL MODULES */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Total Modules</Form.Label>
                <Form.Control
                  type="text"
                  name="total_modules"
                  value={formData.total_modules}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* MODULE CAPACITY */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Each Module Capacity</Form.Label>
                <Form.Control
                  type="text"
                  name="module_capacity"
                  value={formData.module_capacity}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* MODULE MAKE */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Module Make</Form.Label>
                <Form.Control
                  type="text"
                  name="module_make"
                  value={formData.module_make}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>

            {/* MODULE AREA */}
            <Col md={6}>
              <Form.Group className="mb-2">
                <Form.Label>Module Area</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    name="Module_Area"
                    value={formData.Module_Area}
                    onChange={handleChange}
                    required
                  />
                  <InputGroup.Text>
                    m²
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>

            {/* DGR MAIL ID */}
            <Col md={12}>
              <Form.Group className="mb-2">
                <Form.Label>DGR Mail ID</Form.Label>
                <Form.Control
                  type="text"  
                  name="Daily_Mail"
                  value={formData.Daily_Mail}
                  onChange={handleChange}
                  placeholder="e.g. abc@gmail.com; xyz@gmail.com or -"
                />
              </Form.Group>
            </Col>

            {/* EVENT MAIL ID */}
            <Col md={12}>
              <Form.Group className="mb-2">
                <Form.Label>Event Mail ID</Form.Label>
                <Form.Control
                  type="text"
                  name="Event_Mail"
                  value={formData.Event_Mail}
                  onChange={handleChange}
                  placeholder="e.g. abc@gmail.com; xyz@gmail.com or -"
                />
              </Form.Group>
            </Col>
          </Row>

          {/* ADDRESS */}
          <Form.Group className="mb-3 mt-2">
            <Form.Label>Address</Form.Label>
            <Form.Control  
              as="textarea"
              rows={3}
              name="address"
              value={formData.address}
              onChange={handleChange}  
              required
            />
          </Form.Group>

          {/* BUTTONS */} 
          <div className="text-end mt-3">
            <Button  
              variant="secondary"
              onClick={handleClose}
              className="me-2"
            >
              Cancel
            </Button>

            <Button
              type="submit"
              style={{
                backgroundColor: PrimaryColor,
                border: "none",
              }}
            >
              Update
            </Button>
          </div>
        </Form> 
      </Modal.Body>
    </Modal>
  );
};

export default UserDetailUpdate;

